<div class="panel-wrapper">
    <div class="panel-header">
        <span class="panel-header-text">Payment Details</span>
        <span mis-input-icon (click)="close()" class="close-btn"><img src="/assets/images/cancel_24.svg"
                alt="" /></span>
    </div>
    <div class="panel-body">
     <div class="payment-item" *ngFor="let item of payments">
        <div class="payment-item-header">
            <div class="trip-type">{{item.bookingType}}</div>
            <div class="trip-amount">₹ {{item.amount}}</div>
        </div>
        <div class="trip-id">{{item.bookingId}}</div>
        <div class="trip-date">
            {{item.bookingDate | date:'longDate'}}
        </div>
     </div>
    </div>
    <div class="panel-footer" >
       
        <div class="amount">
            <div class="amt-text">Total Amount Due</div>
            <div class="amt-value">₹ {{totalAmt}} </div>
        </div>
        <button mis-button type="primary" size="sm" class="pay-btn" (click)="handlePayment()">Pay Now</button>
    </div>
</div>


   
